import TreemapQueryDataConverter from "./treemapQueryDataConverter";

angular
  .module("acl.visualizer.treemap", [
    "acl.visualizer.charts.controllers",
    "acl.visualizer.charts",
    "acl.visualizer.color",
  ])
  .service("TreemapQueryDataConverter", TreemapQueryDataConverter);
